import { useMemo } from 'react'
import { useApiQuery } from '../../../lib/api'
import type { ChatwootContactsResponse } from '../types'

// Loads account contacts for the operator's "New conversation" picker. A search
// term routes to Chatwoot's /contacts/search server-side; an empty term lists
// all contacts. Paginated upstream (page defaults to 1).
// `reloadKey` lets the caller force a refetch (e.g. a retry button after a
// failed load); bumping it changes the request payload, which re-runs the
// callable. It is stripped server-side, so it never reaches Chatwoot.
export function useChatwootContacts(
  search: string,
  page: number,
  companyUid?: string | null,
  reloadKey = 0
) {
  const requestData = useMemo(
    () => ({
      companyUid: companyUid?.trim() || undefined,
      search: search.trim() || undefined,
      page,
      reloadKey,
    }),
    [companyUid, search, page, reloadKey]
  )

  return useApiQuery<
    { companyUid?: string; search?: string; page: number; reloadKey: number },
    ChatwootContactsResponse
  >('chatwoot/get_contacts', {
    data: requestData,
    startWithValue: { contacts: [], meta: { count: 0, currentPage: page } },
  })
}
